import Select from '../../../../../../components/Select/Select';
import { useEffect, useState } from 'react';
import { Icon } from '../../../../../../components';
import { Icons } from '../../../../../../components/Icon/Icon';
import styles from '../../../../layout/FormLayout/FormLayout.module.css';

const AssetSingle = ({
    selectedData,
    availableItems,
    countries,
    onUpdate,
    handleRemoveItem,
    additionalItems,
    handleShowCreateForm,
}: any) => {
    const [items, setItems] = useState<any[]>(availableItems);

    const [data, setData] = useState({
        domicile: undefined,
        ...selectedData,
    });

    useEffect(() => {
        setItems([...additionalItems, ...availableItems]);
    }, [additionalItems, availableItems]);

    const handleSelectChange = (prop: string) => (selectedData: any) => {
        let value = selectedData;

        if (prop === 'asset') {
            value = items
                .filter((item: any) =>
                    Array.isArray(value)
                        ? selectedData.findIndex((selected: any) => item.assetParticipation === selected.label) > -1
                        : item.assetParticipation === selectedData.label,
                )
                .map((v: any) => ({ ...v, label: v.assetParticipation }));
        }

        const selectedObj = {
            ...data,
            [prop]: value,
        };

        setData(selectedObj);
        onUpdate(selectedObj);
    };

    return (
        <>
            <div className={styles.formGridRow}>
                <Select
                    value={data.domicile}
                    onChange={handleSelectChange('domicile')}
                    options={countries}
                    valueKey={'domicileId'}
                    labelKey={'domicileName'}
                    placeholder={'Choose domicile'}
                    afterLabel={
                        <button
                            style={{
                                minWidth: 32,
                            }}
                            type={'button'}
                            onClick={handleRemoveItem}
                        >
                            <Icon icon={Icons.closeRounded} />
                        </button>
                    }
                >
                    Domicile
                </Select>

                <Select
                    value={data.asset}
                    disabled={!data.domicile}
                    isMulti={true}
                    onChange={handleSelectChange('asset')}
                    options={items}
                    valueKey={'assetParticipation'}
                    labelKey={'assetParticipation'}
                    filterKey={'participationForm'}
                    onCreateOption={handleShowCreateForm}
                    placeholder={'Choose asset and allocation type'}
                >
                    Asset Type
                </Select>
            </div>
        </>
    );
};

export default AssetSingle;
